/*
 * ****************************************************************************
 * Copyright (C) 2018-2018, All rights reserved.
 * Project: chessmate
 * Created On: March 23rd, 2018
 * Last Modified: March 23rd, 2018
 * ****************************************************************************
 */

import * as React from 'react';
import * as Mui from 'mui';

/** BarButtonProps - Properties */
export interface BarButtonProps {
  icon: string;
  text?: string;
  onClick?: (e: any) => void;
  disabled?: boolean;
}

/** BarButton */
export class BarButton extends React.Component<BarButtonProps> {
  constructor(props: BarButtonProps, ctx: any) {
    super(props, ctx);
  }

  onClicked = (e: React.SyntheticEvent<any>) => {
    e.preventDefault();
    if (this.props.onClick && !this.props.disabled) {
      this.props.onClick(e);
    }
  };

  render() {
    const { icon, text, onClick, ...props } = this.props;
    return (
      <Mui.Typography component="div" color="textSecondary" onTouchEnd={this.onClicked}>
        {!!text ? (
          <Mui.Button className="icon-text-button" color="inherit" {...props} onClick={this.onClicked}>
            <Mui.Icon>{icon}</Mui.Icon>{text}
          </Mui.Button>
        ) : (
            <Mui.IconButton className="icon-button" disableRipple {...props} onClick={this.onClicked}>
              <Mui.Icon>{icon}</Mui.Icon>
            </Mui.IconButton>
          )}
      </Mui.Typography>
    );
  }
}

export default BarButton;


// WEBPACK FOOTER //
// ./src/components/barButton.tsx